import { render, staticRenderFns } from "./AddonEdit.vue?vue&type=template&id=1ea6a787&scoped=true&"
import script from "./AddonEdit.vue?vue&type=script&lang=js&"
export * from "./AddonEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddonEdit.vue?vue&type=style&index=0&id=1ea6a787&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea6a787",
  null
  
)

export default component.exports